/**
 * Whether `key` is an own property of `value`, so an inherited name such as `toString` is not
 * mistaken for an entry. `Object.hasOwn` does the same check, but this one also narrows `key`
 * to a key of `value`'s type.
 */
function hasOwnKey<T extends object>(value: T, key: PropertyKey): key is keyof T {
    return Object.hasOwn(value, key);
}

export default hasOwnKey;
